import React from "react";
import cns from "classnames";
import { Chip, makeStyles } from "@material-ui/core";
import { CustomerType } from "@graphql";
import locale from "@bonliva-crm/locale";

type CustomerChipProps = {
  type: CustomerType;
  style?: React.CSSProperties;
};

const customerRegionColor = "#91a0a7";
const customerHospitalColor = "#b29987";
const customerDeptColor = "#c2762f";

export const CustomerChip: React.FC<CustomerChipProps> = ({ type, style }) => {
  const classes = useStyles({});
  return (
    <Chip
      variant="outlined"
      label={locale.customerType[type]}
      style={style}
      className={cns(classes.chip, {
        [classes.chipRegion]: type === CustomerType.Region,
        [classes.chipHospital]: type === CustomerType.Hospital,
        [classes.chipDept]: type === CustomerType.Department
      })}
    />
  );
};

export function getCustomerColor(type: CustomerType) {
  return type === CustomerType.Region
    ? customerRegionColor
    : type === CustomerType.Hospital
    ? customerHospitalColor
    : customerDeptColor;
}

const chipMixing = (color: string) => ({
  borderColor: color,
  backgroundColor: "none",
  "& span, & svg": {
    color,
    fontWeight: "regular"
  }
});

const useStyles = makeStyles({
  chip: {
    height: 24,

    "& span": {
      paddingLeft: 8,
      paddingRight: 8
    },

    "& > div": {
      backgroundColor: "transparent !important"
    }
  },

  chipRegion: chipMixing(getCustomerColor(CustomerType.Region)),
  chipHospital: chipMixing(getCustomerColor(CustomerType.Hospital)),
  chipDept: chipMixing(getCustomerColor(CustomerType.Department))
});

export default CustomerChip;
